import one from "../assets/svg/projects/one.svg";
import two from "../assets/svg/projects/two.svg";
import three from "../assets/svg/projects/three.svg";
import four from "../assets/svg/projects/four.svg";
import five from "../assets/svg/projects/five.svg";
import six from "../assets/svg/projects/six.svg";
import seven from "../assets/svg/projects/seven.svg";
import eight from "../assets/svg/projects/eight.svg";

export const projectsData = [
  {
    id: 1,
    projectName: "String Analyser",
    projectDesc:
      "This project is a string analyser that allows users to obtain relevant information about the string user inputs.",
    tags: ["HTML", "CSS", "Javascript"],
    code: "https://github.com/harsh-rajpal/Task-3",
    demo: "https://harsh-rajpal-task-3.netlify.app/",
    image: one,
  },
  {
    id: 2,
    projectName: "Expense Calculator",
    projectDesc:
      "This project is a expense calculator that allows users to calculate their expenses and income.",
    tags: ["HTML", "CSS", "Javascript"],
    code: "https://github.com/harsh-rajpal/Expense-calculator",
    demo: "https://harsh-task2.netlify.app/",
    image: two,
  },
  {
    id: 3,
    projectName: "Linktree",
    projectDesc:
      "A linktree clone that contains all the links of my club and its social media handles.",
    tags: ["HTML", "CSS", "Javascript"],
    code: "https://github.com/hhhrrrttt222111/developer-portfolio",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: three,
  },
  {
    id: 4,
    projectName: "Portfolio Website ",
    projectDesc:
      "A portfolio website that contains all the information about me and my projects which I made as a begineer.",
    code: "https://github.com/harsh-rajpal/task-1-adg",
    demo: "https://harsh-porfolio1.netlify.app/",
    image: four,
  },
  {
    id: 5,
    projectName: "E-Commerce App",
    projectDesc: "A Simple E-commerce application",
    tags: ["React Native", "Firebase"],
    code: "https://github.com/hhhrrrttt222111/developer-portfolio",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: five,
  },
  {
    id: 6,
    projectName: "Uber Lite",
    projectDesc: "Uber clone",
    tags: ["Flutter"],
    code: "https://github.com/hhhrrrttt222111/developer-portfolio",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: six,
  },
  {
    id: 7,
    projectName: "Stock Market App",
    projectDesc: "A simple stock market API app",
    tags: ["React", "Redux", "Bootstrap"],
    code: "https://github.com/hhhrrrttt222111/developer-portfolio",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: seven,
  },
  {
    id: 8,
    projectName: "Car Pooling System",
    projectDesc:
      "The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution",
    tags: ["Flutter", "React"],
    code: "https://github.com/hhhrrrttt222111/developer-portfolio",
    demo: "https://github.com/hhhrrrttt222111/developer-portfolio",
    image: eight,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
